import { Typography } from '@mui/material'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Cell, Template } from '@/core/architecture'

import { MailAuthForm, MailAuthFormProps } from './MailAuthForm'

export * from './fragments'

export type State = {
  loading: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onResendAuthMail: MailAuthFormProps['onResendAuthMail']
  onSubmitMailAuth: MailAuthFormProps['onSubmitMailAuth']
}

export const MailAuthTemplate: Template<State, Action> = ({
  state,
  onResendAuthMail,
  onSubmitMailAuth,
}) => {
  const { t } = useTranslation('mailAuth')
  const { routerNames } = useRouter()

  return (
    <>
      <Head title={routerNames.MailAuth} />
      <BaseLayout margin header={{ back: true, title: t('title') }}>
        <Typography variant="body2" sx={{ py: 2 }}>
          {t('description')}
        </Typography>
        <MailAuthForm
          loading={state.loading}
          onResendAuthMail={onResendAuthMail}
          onSubmitMailAuth={onSubmitMailAuth}
        />
      </BaseLayout>
    </>
  )
}

export const SomethingCell: Cell = () => null
